import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../hooks/Language';

import { Container } from './styles';

const Logo: React.FC = () => {

  const { language } = useLanguage();
  const [logoValue, setLogoValue] = useState("/assets/logo2.png");


  useEffect(() => {

    const validLogo = {
      ptBr: "/assets/logo2.png",
      en: "/assets/logo2.png",
      es: "/assets/logo2.png",
    }


    setLogoValue(validLogo?.[language] ? validLogo[language] : logoValue);

  }, [language])

  return (
    <Container>
      <img src={logoValue} />
    </Container>
  );
};
export default Logo;
